module.exports = __webpack_public_path__ + "c514c751927d079fe1d87e09aef5e229.svg";